export const COW_FILTERS_RESET_ALL = 'COW_FILTERS_RESET_ALL';
// export const COW_FILTERS_SET_LOCATION = 'COW_FILTERS_SET_LOCATION';
// export const COW_FILTERS_SET_DISTANCE = 'COW_FILTERS_SET_DISTANCE';
export const COW_FILTERS_SET_MIN_SCORE = 'COW_FILTERS_SET_MIN_SCORE';
export const COW_FILTERS_SET_MAX_SCORE = 'COW_FILTERS_SET_MAX_SCORE';
export const COW_FILTERS_SET_MIN_PRICE = 'COW_FILTERS_SET_MIN_PRICE';
export const COW_FILTERS_SET_MAX_PRICE = 'COW_FILTERS_SET_MAX_PRICE';
export const COW_FILTERS_SET_MIN_AGE = 'COW_FILTERS_SET_MIN_AGE';
export const COW_FILTERS_SET_MAX_AGE = 'COW_FILTERS_SET_MAX_AGE';
export const COW_FILTERS_SET_ATTRIBUTES = 'COW_FILTERS_SET_ATTRIBUTES';
export const COW_FILTERS_SET_BREEDS = 'COW_FILTERS_SET_BREEDS';
export const COW_FILTERS_SET_TYPE = 'COW_FILTERS_SET_TYPE';
export const COW_FILTERS_SET_VISIBLE = 'COW_FILTERS_SET_VISIBLE';
export const COW_FILTERS_SET_FAVOURITED = 'COW_FILTERS_SET_FAVOURITED';
export const COW_FILTERS_SET_INTERESTED = 'COW_FILTERS_SET_INTERESTED';
export const COW_FILTERS_SET_SEARCH = 'COW_FILTERS_SET_SEARCH';
